import styles from './StatGrid.module.css';
import { Spinner } from './Spinner';

type StatItem = {
  readonly label: string;
  readonly value: string | number | null;
  readonly color: 'accent' | 'warning' | 'default';
  readonly onClick: (() => void) | null;
};

type StatGridProps = {
  readonly items: ReadonlyArray<StatItem>;
};

const StatGrid = ({ items }: StatGridProps): React.ReactElement => (
  <div className={styles.grid}>
    {items.map((item) => (
      <div
        key={item.label}
        className={`${styles.card}${item.onClick ? ` ${styles.clickable}` : ''}`}
        onClick={item.onClick ?? undefined}
        role={item.onClick ? 'button' : undefined}
        tabIndex={item.onClick ? 0 : undefined}
      >
        <div className={styles.label}>{item.label}</div>
        <div className={`${styles.value} ${item.color === 'accent' ? styles.valueAccent : item.color === 'warning' ? styles.valueWarning : ''}`}>
          {item.value !== null ? item.value : <Spinner />}
        </div>
      </div>
    ))}
  </div>
);

export { StatGrid };
export type { StatItem };
